import State from 'store/State';
import { WidgetsSharedConfigState } from 'widgets/store/sharedConfiguration/WidgetsSharedConfigState';

export const selectWidgetsSharedConfigState: (
    state: State
) => WidgetsSharedConfigState = (state) => state.widgets.sharedConfig;
